module.exports = __webpack_public_path__ + "static/ziarno_stojaca-9ba43ada47a2801d3b8da4a70634848a.png";